module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-L-14.a0005245.png";